import { queryKeys } from '@/lib/query-keys';
import type {
} from '@octave/contracts';
import type { PhonePlan } from '@octave/contracts';
import {
  useQuery,
  } from '@tanstack/react-query';
import {
  phonePlanClient,
} from '@/lib/api/ts-rest';


export const usePhonePlans = (
  organizationId: string | undefined,
  operatorId: string | undefined,
  mobileLineType?: 'classic' | 'dataonly'
) => {
  return useQuery<PhonePlan[], Error>({
    queryKey: queryKeys.catalog.phonePlans(organizationId, operatorId, mobileLineType),
    queryFn: async () => {
      const res = await phonePlanClient.listPhonePlans({
        params: { organizationId: organizationId! },
        query: { operatorId, mobileLineType },
      });
      if (res.status !== 200) throw new Error('Failed to load plans');
      return res.body;
    },
    enabled: !!organizationId && !!operatorId,
  });
};
